<template>
  <div ref="container" class="large-text-container" @click="toggle">
    <div ref="node" :class="['message', { hide }]" v-html="message"></div>
    <div v-if="enabled" class="toggle">
      {{ hide ? $t('zhan-kai') : $t('shou-qi') }}
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    message: string
    rowCount?: number
  }>(),
  {
    rowCount: 2,
  }
)

const hide = ref(false)
const enabled = ref<boolean>(false)
const node = ref<HTMLDivElement>()

function getNodeLineHeight(dom: HTMLDivElement) {
  const styleMap = dom.computedStyleMap()
  const lineHeight = styleMap.get('line-height') as CSSUnitValue
  const fontSize = styleMap.get('font-size') as CSSUnitValue
  const unit = lineHeight.unit

  switch (unit) {
    case 'px': // 28px
      return lineHeight.value
    case 'number': // 1.5
      return fontSize.value * lineHeight.value
  }

  return 0
}

onMounted(() => {
  const height = node.value!.getBoundingClientRect().height
  const lineHeight = getNodeLineHeight(node.value!)

  if (height > props.rowCount * lineHeight) {
    enabled.value = true
    hide.value = true
  }
})

const toggle = () => {
  hide.value = !hide.value
}
</script>

<style lang="scss" scoped>
.message {
  position: relative;
  cursor: pointer;
  &.hide {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.toggle {
  position: absolute;
  cursor: pointer;
  right: 0;
  bottom: -28px;
  color: var(--primary-color);
}
</style>
